export const UiTypes = {
  HIDE_NAVIGATION: 'HIDE_NAVIGATION',
  SHOW_NAVIGATION: 'SHOW_NAVIGATION',
  SET_WORK_LOADED_FALSE: 'SET_WORK_LOADED_FALSE',
  SET_WORK_LOADED_TRUE: 'SET_WORK_LOADED_TRUE',

};